module.exports = __webpack_public_path__ + "img/logo_estado.8c4b82bc.svg";